/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type InputTokenDetails = {
  cachedTokens?: number | undefined;
};

/** @internal */
export const InputTokenDetails$inboundSchema: z.ZodType<
  InputTokenDetails,
  z.ZodTypeDef,
  unknown
> = z.object({
  cached_tokens: z.number().int().default(0),
}).transform((v) => {
  return remap$(v, {
    "cached_tokens": "cachedTokens",
  });
});
/** @internal */
export type InputTokenDetails$Outbound = {
  cached_tokens: number;
};

/** @internal */
export const InputTokenDetails$outboundSchema: z.ZodType<
  InputTokenDetails$Outbound,
  z.ZodTypeDef,
  InputTokenDetails
> = z.object({
  cachedTokens: z.number().int().default(0),
}).transform((v) => {
  return remap$(v, {
    cachedTokens: "cached_tokens",
  });
});

export function inputTokenDetailsToJSON(
  inputTokenDetails: InputTokenDetails,
): string {
  return JSON.stringify(
    InputTokenDetails$outboundSchema.parse(inputTokenDetails),
  );
}
export function inputTokenDetailsFromJSON(
  jsonString: string,
): SafeParseResult<InputTokenDetails, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InputTokenDetails$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InputTokenDetails' from JSON`,
  );
}
